// Design Tokens - Spacing
// Use these tokens for all padding, margin, and gap values
// Based on FarLabs modern design system

export const spacing = {
  // Named spacing - Enhanced scale
  xxs: '2px',
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  '2xl': '48px',
  '3xl': '64px',
  '4xl': '96px',
  '5xl': '128px',

  // Scale (for precise control)
  scale: {
    0: '0px',
    0.5: '2px',
    1: '4px',
    1.5: '6px',
    2: '8px',
    2.5: '10px',
    3: '12px',
    3.5: '14px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '28px',
    8: '32px',
    9: '36px',
    10: '40px',
    11: '44px',
    12: '48px',
    14: '56px',
    16: '64px',
    20: '80px',
    24: '96px',
    28: '112px',
    32: '128px',
    36: '144px',
    40: '160px',
    44: '176px',
    48: '192px',
    52: '208px',
    56: '224px',
    60: '240px',
    64: '256px',
    72: '288px',
    80: '320px',
    96: '384px',
  },

  // Component-specific spacing
  component: {
    buttonPadding: {
      sm: '8px 16px',
      md: '12px 24px',
      lg: '16px 32px',
    },
    cardPadding: {
      sm: '16px',
      md: '24px',
      lg: '32px',
    },
    inputPadding: {
      sm: '8px 12px',
      md: '12px 16px',
      lg: '16px 20px',
    },
    sectionSpacing: {
      sm: '48px',
      md: '64px',
      lg: '96px',
      xl: '128px',
    },
  },
} as const;
